import { React, models, kea, history, resources, selectores, componentToRx } from "app/main/std";
import { Link } from "react-router-dom";
import { Usuario } from "./usuarioButton";
import { NotificacionesZE, itemsNotificaciones } from "./entregaZEButton";
import { onCerrarSesion } from "app/logic/login";
import { NavBarItem } from "kea-react";
import { observeResource } from "kea-resource";

interface Props {
    permisos: models.Rol;
    esDePrueba: boolean;
    path: string;
}

interface NavBarLink {
    content: string;
    route: string;
    visible?: boolean
}
function toNavBarItems(links: NavBarLink[], path: string): NavBarItem[] {
    return links.map(x => ({
        content: x.content,
        onClick: () => x.route.includes("http") ? history.goExtRoute( x.route) :  history.go(x.route),
        selected: path == x.route,
        visible: x.visible
    } as NavBarItem));
}

class HeaderComp extends React.PureComponent<Props> {
    render() {
        const { permisos, path, esDePrueba } = this.props;
        return (
            <kea.NavBar
                color="white"
                background={esDePrueba ? "#4C9900" : "#e86338"}
                header={[

                ]}
                left={toNavBarItems([
                    {
                        content: "Uruz",
                        route: "/"
                    }, {
                        content: "Operación",
                        route: "/operativa",
                        visible: !!permisos.VerOperacion
                    }, {
                        content: "Documentar",
                        route: "/operativa/documentar",
                        visible: !!permisos.Documentacion.VerCabecera
                    }, {
                        content: "Cotizar",
                        route: "/operativa/cotizar",
                        visible: !!permisos.Cotizar.VerEncabezado
                    }, {
                        content: "Catálogos",
                        route: "/catalogos",
                        visible: !!permisos.Catalogos.VerCabecera
                    }, {
                        content: "Ocurre",
                        route: "/operativa/ocurre",
                        visible: !!permisos.EntregaOcurre.VerCabecera
                    }, {
                        content: "QR",
                        route: "/operativa/qr",
                        visible: !!permisos.PermisosQR.VerEncabezado
                    }, {
                        content: "Buzón de sugerencias",
                        //route: "https://forms.office.com/FormsPro/Pages/ResponsePage.aspx?id=J-8QmwPQ7kKf5gU204UWsvPOblvLUmdJrelDbBJB9EFUQzBKRExOU1hEUkRLU1daVlFWVkNKWlJWQi4u",
                        route: "https://forms.office.com/pages/responsepage.aspx?id=J-8QmwPQ7kKf5gU204UWsvPOblvLUmdJrelDbBJB9EFUQzBKRExOU1hEUkRLU1daVlFWVkNKWlJWQi4u",
                        visible: !!permisos.BotonSugerencias_VerEncabezado
                    }
                ], path)}
                right={[
                    {
                        content: <Usuario />,
                        items: [
                            {
                                content: "Ir a login",
                                onClick: () => history.go("/login"),
                            }, {
                                content: "Cerrar sesión",
                                onClick: onCerrarSesion
                            }, {
                                content: "Configuración del sistema paqueteria",
                                onClick: () => history.go("/configuracion"),
                                visible: !!permisos.Configuraciones.EditarConfiguraciones
                            }, {
                                content: "Configuración del sistema logistica",
                                onClick: () => history.go("/configuracionLogistica"),
                                visible: !!permisos.Configuraciones.EditarConfiguraciones
                            }
                        ]
                    }
                ]}
            />
        )
    }
}

const HeaderRx = componentToRx(HeaderComp);

export class Header extends React.PureComponent {
    esDePrueba = observeResource(resources.ConfigSistema.EsDePruebas);
    render() {
        return (
            <HeaderRx permisos={resources.User.PermisoRx} path={history.pathRx} esDePrueba={this.esDePrueba} />
        );
    }
}


// WEBPACK FOOTER //
// ./app/features/inicio/header.tsx